import { useMemo, useState } from 'react';
import { rebalance } from '../../../engine/portfolioBot';

export function PortfolioBotPanel() {
  const [band, setBand] = useState<'low'|'medium'|'high'>('medium');
  const [risk, setRisk] = useState(0.5);
  const plan = useMemo(()=> rebalance({ volatilityBand: band, targets:{ erg:33, offsets:33, futures:34 }, riskAppetite: risk }), [band, risk]);
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3">
      <div className="font-orbitron text-evat-gold">Portfolio Bot</div>
      <div className="flex gap-3 text-sm items-center">
        <label className="flex items-center gap-2">Volatility
          <select value={band} onChange={(e)=>setBand(e.target.value as any)} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1">
            {['low','medium','high'].map(b=> <option key={b} value={b}>{b}</option>)}
          </select>
        </label>
        <label className="flex items-center gap-2">Risk appetite
          <input type="range" min={0} max={1} step={0.1} value={risk} onChange={(e)=>setRisk(Number(e.target.value))} />
        </label>
      </div>
      <div className="text-neutral-300">ERG: <span className="text-evat-neon">{plan.erg}%</span> • Offsets: <span className="text-evat-gold">{plan.offsets}%</span> • Futures: <span className="text-evat-neon">{plan.futures}%</span></div>
      <div className="text-xs text-neutral-500">{plan.note}</div>
    </div>
  );
}

export default PortfolioBotPanel;



















